import { render, staticRenderFns } from "./InfoBoxBankDetailsTest.vue?vue&type=template&id=27a2a3ea&scoped=true"
import script from "./InfoBoxBankDetailsTest.vue?vue&type=script&lang=js"
export * from "./InfoBoxBankDetailsTest.vue?vue&type=script&lang=js"
import style0 from "./InfoBoxBankDetailsTest.vue?vue&type=style&index=0&id=27a2a3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a2a3ea",
  null
  
)

export default component.exports